<template>
  <div class="card mt-2">
    <div class="card-header">
      <i class="fa fa-address-book-o"></i> Novo
      Ssv 2303 Confi Auto Fncra
    </div>

    <b-form ref="form" @submit.prevent="onSubmit" @reset="onReset">

      <ssv2303-confi-auto-fncra-form :ssv2303ConfiAutoFncra="ssv2303ConfiAutoFncra" :violations="violations"></ssv2303-confi-auto-fncra-form>

      <div class="row">
        <div class="form-group col-sm-12 mb-2 mr-1 text-right">
          <button class="btn-sm btn btn-sm btn-outline-success mr-1" type="submit" data-toggle="tooltip" data-placement="bottom" title="Salvar">
            <i class="fa fa-floppy-o"></i> Salvar
          </button>

          <button class="btn btn-sm btn-outline-danger mr-1" type="button" data-toggle="tooltip" data-placement="bottom" title="Limpar" @click="onReset()">
            <i class="fa fa-eraser"></i> Limpar
          </button>

          <button class="btn btn-sm btn-outline-dark mr-1" type="button" data-toggle="tooltip" data-placement="bottom" @click="$router.go(-1)" title="Voltar">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex";
  
  import store from "@/store";
  
  import {  
    CREATE_SSV2303_CONFI_AUTO_FNCRA,  
    RESET_SSV2303_CONFI_AUTO_FNCRA
  } from "@/store/actions.type";
  
  import Ssv2303ConfiAutoFncraForm from '@/components/Ssv2303ConfiAutoFncraForm';
  
  export default {
    components: {
      Ssv2303ConfiAutoFncraForm
    },
  
    data() {
      return {
  	 violations: {},
       responseMessage: null,
       successORError: null,
      };
    },
  
    computed: {
      ...mapGetters(['ssv2303ConfiAutoFncra'])
    },
  
    methods: {
      onSubmit() {
        this.violations = {};
        return this.$store.dispatch(CREATE_SSV2303_CONFI_AUTO_FNCRA)
          .then(ssv2303ConfiAutoFncra => {
          	 this.flash().destroyAll();
               this.flashSuccess("Registro criado com sucesso.");
               this.$router.push({
                   name: 'ssv2303-confi-auto-fncra-edit',
                   params: { id: ssv2303ConfiAutoFncra.cdCrtor + '-' + ssv2303ConfiAutoFncra.dtInicoVigen }
               });
              store.dispatch(RESET_SSV2303_CONFI_AUTO_FNCRA);
          })
          .catch(response => {
            this.flash().destroyAll();
            this.flashError("Ocorreu um erro ao tentar realizar cadastro.");
            if (response.body.violations) this.violations = response.body.violations;
            throw response.body.message;
          });
      },
      onReset() {
        this.violations = {};
        store.dispatch(RESET_SSV2303_CONFI_AUTO_FNCRA);
      }
    },
  
    async beforeRouteEnter(to, from, next) {
      await store.dispatch(RESET_SSV2303_CONFI_AUTO_FNCRA);
      return next();
    }
  };
</script>